var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    class: ['button', 'secondary', 'buy-panel-save-design', {
      'buy-panel-add-to-cart-loading': _vm.saveDesignLoading,
      'full-width': _vm.isUGCApplied && !_vm.tmallIsUGCMS || _vm.onlyFavorites
    }],
    attrs: {
      "disabled": _vm.disableSaveDesignButton || _vm.disableSaveDesign,
      "type": "button"
    },
    on: {
      "click": _vm.saveDesign
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.saveDesignLoading,
      expression: "!saveDesignLoading"
    }]
  }, [_vm._v(_vm._s(_vm.translations.buyPanelTmallSaveDesign))]), _c('base-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.saveDesignLoading,
      expression: "saveDesignLoading"
    }],
    staticClass: "buy-panel-add-to-cart-spinner",
    attrs: {
      "size": "40"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }